import { Svg } from "@impero-com/ui";

import * as theme from "./emptyTableBox.css";

interface EmptyTableBoxProps {
    text: string;
    svgIcon: string;
}

/**
 * A component that fill the place and displays a message when a table is empty.
 * Is meant to be used only in Dashboard.
 * For other use cases, you most likely want to use `EmptyTableBox` from @impero-com/ui.
 */
export function EmptyTableBox({ text, svgIcon }: EmptyTableBoxProps) {
    return (
        <div className={theme.container}>
            <Svg className={theme.icon} src={svgIcon} />
            <div className={theme.text}>{text}</div>
        </div>
    );
}
